import { createFileRoute } from "@tanstack/react-router"

import { ProtectedLayout } from "@/layouts/ProtectedLayout"
import { TOKEN_NAME } from "@/api/client.ts"
import { redirect } from "@tanstack/router-core"
import { UserProvider } from "@/contexts/UserContext.tsx"


export const Route = createFileRoute("/_protected")({
  ssr: false,
  beforeLoad: ({ location }) => {
    const token = localStorage.getItem(TOKEN_NAME)

    if (!token) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
        replace: true,
      })
    }
  },
  component: () => (
    <UserProvider>
      <ProtectedLayout />
    </UserProvider>
  ),
})
